import openMegaMenu from 'redux/modules/mega-menu/actions/open-mega-menu';
import resetMegaMenu from 'redux/modules/mega-menu/actions/reset-mega-menu';

export default () => dispatch => {
  dispatch(resetMegaMenu());
  dispatch(openMegaMenu());
};
